export function showScrollbar() {
  const el = document.querySelector(".cover-bar")
  el?.classList.add("scrollbar-visible")
}

export function hideScrollbar() {
  const el = document.querySelector(".cover-bar")
  el?.classList.remove("scrollbar-visible")
}
